import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { DealIcons, } from '@/commons/dictionaries/DealIcons';
import { computed } from 'vue';
import FpSvgIcon from '@/components/fpComponents/FpSvgIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DealAvatar',
  props: {
    productType: null,
    size: { default: '40px' },
    draft: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { productType: string, size: string, draft: boolean };

_useCssVars((_vm, _setup) => ({
  "b50e17d8": (_setup.baseColor),
  "7dcc8fa0": (_setup.bgColor),
  "8245f128": (_setup.iconColor)
}))



const color = computed(() => {
  switch (props.productType) {
    case 'productTypeMortgage':
      return 'mortgage';
    case 'productTypeCash':
      return 'cash';
    case 'productTypeSme':
    case 'productTypeSmeFactoring':
    case 'productTypeSmeLeasing':
      return 'sme';
    case 'productTypeRealEstate':
      return 'realEstate';
    case 'productTypeInsurance':
    case 'productTypeInsuranceLife':
    case 'productTypeInsuranceMedical':
    case 'productTypeInsuranceVehicle':
    case 'productTypeInsuranceAssets':
      return 'insurance';
    default:
      return 'mortgage';
  }
});

const bgColor = computed(() => {
  return `var(--token-${color.value}-surface)`;
});

const baseColor = computed(() => {
  return `var(--token-${color.value}-base)`;
});

const iconColor = computed(() => {
  return `var(--token-${color.value}-text)`;
});


return { __sfc: true,props, color, bgColor, baseColor, iconColor, DealIcons, FpSvgIcon }
}

})